/**
* @Description: EXAM_THREE_VIDEO_TWO
* @author XuZiYu
* @date 2021/12/10 17:37:58
*/
<template>
    <div class="wrapper">
        <div v-if="!autoOpen" style="background: #5D75C4">

            <!--头部-->
            <template v-if="!H5 && headVisible !== '0'">
                <div class="header">
                    <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
                    <div class="header-main">科目三考场视频VIP</div>
                    <div class="header-right">
                        <img v-if="shareVisible" @click="openSharePanel" src="@/assets/public/icon_fx01.png" alt=""></div>
                </div>
                <!--头部占位-->
                <div class="header-pre"></div>
            </template>

            <!--分享框架-->
            <share-ad :detail="shareData">
                <div class="bg">
                    <van-sticky @scroll="scroll" v-if="examVisible">
                        <div :class="['video-wrap',fixed && 'top']">
                            <div class="video-header">
                                <div class="header-left" v-if="fixed" @click="goBack">
                                    <img src="@/assets/vip/icon_back1.png" alt=""/>
                                </div>
                                <div class="title">{{videoList[0] && videoList[0].examPlaceName}}</div>
                                <div class="btn-go-exam" @click="goAllExam">全部考场></div>
                            </div>
                            <div class="video-list">
                                <div class="video-item" v-for="(v,i) in videoList" :key="i" @click="goExam(v)">
                                    <img class="cover" :src="v.coverUrl" alt="">
                                    <div class="play">
                                        <van-icon name="play-circle-o"/>
                                    </div>
                                    <span class="time">{{formatSeconds(v.duration)}}</span>
                                </div>
                            </div>
                        </div>
                    </van-sticky>
                    <div class="bg-other" :style="{marginTop: examVisible ?  '' : '200px'}">
                        <img src="@/assets/videoVip/k3-2.png" alt=""/>
                        <img src="@/assets/videoVip/k3-3.png" alt=""/>
                        <img src="@/assets/videoVip/k3-4.png" alt=""/>
                        <img src="@/assets/videoVip/k3-5.png" alt=""/>
                    </div>
                    <div class="bg-first">
                        <img src="@/assets/videoVip/k3-1.png" alt=""/>
                    </div>
                    <div class="rule">
                        <p><b class="index">1</b>考场视频VIP服务，有效期为<b class="number">{{examVideoData.effectiveDays}}天</b>，购买后即刻生效。
                        </p>
                        <p><b class="index">2</b>考场视频VIP服务为虚拟产品，不支持退款， 请知悉后再购买。</p>
                        <p><b class="index">3</b>如有疑问，请联系{{examVideoData.phone}}。</p>
                    </div>
                    <div class="rule second">
                        <p><b class="index">1</b>购买前请注册/登录App账号，购买成功后，<br/>需要登录您购买时的账号才能享受VIP服务。</p>
                        <p><b class="index">2</b>如有疑问或需要帮助，请联系平台客服咨询。</p>
                    </div>
                </div>
            </share-ad>

            <!--底部-->
            <div class="footer">
            <span v-if="examVideoData.openMode === 1" class="second">
                限时领取 <b>（分享激活）</b>
            </span>
                <span v-else class="first">
              <b v-if="examVideoData.openMode === 3" class="top">{{examVideoData.pointNum}}斑豆</b>
              <b v-if="examVideoData.openMode === 2" class="top">¥{{examVideoData.payConPrice > 0 ? examVideoData.payConPrice : examVideoData.payOrigPrice}}{{examVideoData.payConPoint ? ` + ${examVideoData.payConPoint}斑豆` : ''}}</b>
              <b v-if="examVideoData.openMode === 2 && examVideoData.payConPrice > 0" class="bottom">原价{{examVideoData.payOrigPrice}}</b>
            </span>

                <!--车型判断是否显示购买按钮-->
                <template v-if="Number(carType) === 1">
                    <van-button v-if="IOS" class="recovery" @click="submit" :loading="loading">恢复购买</van-button>
                    <van-button class="fourth" @click="submit" :loading="loading">立即开通</van-button>
                </template>

                <template v-else>
                    <div class="btn-none-buy">仅适用于C1/C2学员</div>
                </template>
            </div>

        </div>
        <!--底部占位-->
        <div class="footer-pre"></div>

        <!--消息弹出框-->
        <ctl-dialog v-model="messageDialog" :loading="loading"/>
    </div>
</template>

<script>
import dialog from '@/components/dialog/index.vue'
import { Toast, Button, Icon, Sticky } from 'vant'

export default {
    name: 'index',
    components: {
        ctlDialog: dialog,
        [Button.name]: Button,
        [Sticky.name]: Sticky,
        [Icon.name]: Icon
    },
    methods: {
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 滚动事件
        scroll (v) {
            if (Number(this.headVisible) === 0) {
                this.fixed = false
            } else {
                this.fixed = v.isFixed
            }
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 跳转所有考场
        goAllExam () {
            this.$jsBridge.callBackHandler('pushExamPlaceRoutePage', { subject: '3' })
        },
        // 跳转考场详情
        goExamDetail (v) {
            this.$jsBridge.callBackHandler('pushVideoDetailPage', { itemJson: JSON.stringify(v), subject: 3 })
        },
        // 分钟计算
        formatSeconds (s) {
            s = parseInt(s)
            // 计算分钟
            // 算法：将秒数除以60，然后下舍入，既得到分钟数
            let h
            h = Math.floor(s / 60)
            // 计算秒
            // 算法：取得秒%60的余数，既得到秒数
            s = s % 60
            // 将变量转换为字符串
            h += ''
            s += ''
            // 如果只有一位数，前面增加一个0
            h = (h.length === 1) ? '0' + h : h
            s = (s.length === 1) ? '0' + s : s
            return h + ':' + s
        },
        // 处理错误码
        handleErrorCode (v) {
            if (v.code === '666') {
                Toast.fail(v.message)

                if (this.autoOpen) {
                    this.$jsBridge.callBackHandler('openFail', { msg: v.message })
                }
            }

            if (v.code === '1004') {
                if (this.autoOpen) {
                    this.$jsBridge.callBackHandler('openFail', { msg: v.message })
                    return
                }
                if (this.$jsBridge.hasNativeMethod('pushFeedBackPage')) {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '遗憾放弃',
                        leftBtnName: '我要反馈',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false

                            // 跳转app意见反馈
                            this.$jsBridge.callBackHandler('pushFeedBackPage')
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        title: '温馨提示',
                        content: v.message
                    }
                } else {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '我知道了',
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        title: '温馨提示',
                        content: v.message
                    }
                }
            }
        },
        // 开通
        submit () {
            // H5标记不能购买
            if (this.H5) {
                this.linkApp()
                return
            }

            // 判断是否已经购买
            if (this.vipData.vipFlag) {
                // 开通处理
                this.openSuccess()
                return
            }

            // 班豆支付
            if (this.examVideoData.openMode === 3) {
                this.beanOpenModel()
            }
            // 金钱支付
            if (this.examVideoData.openMode === 2) {
                this.moneyOpenModel()
            }
            // 分享激活
            if (this.examVideoData.openMode === 1) {
                this.shareOpenModel()
            }
        },
        // 开通成功统一处理
        openSuccess () {
            // 回调App开通成功
            this.$jsBridge.callBackHandler('openSuccess', { vipVideoType: '3' })
        },
        // 斑豆开通方式
        beanOpenModel () {
            // 没有用户id && 去登录
            if (!this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')
                return
            }

            this.messageDialog = {
                visible: true,
                rightBtnName: '确认',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.messageDialog.visible = false
                },
                rightBtnMethod: () => {
                    // 请求数据
                    let postData = {
                        currentUserId: this.userInfo.userId,
                        cityCode: this.cityCode,
                        tryBuyFlag: true,
                        subject: '3'
                    }

                    this.loading = true

                    this.$api.bbBeanOpenExamVideo(postData).then(res => {
                        this.loading = false

                        // 开通成功
                        if (res.result === null && res.status && res.code === '200') {
                            // 开通处理
                            this.openSuccess()
                        }

                        // 斑豆异常处理
                        if (res.message.indexOf('斑豆不足') > -1) {
                            // 自动开通错误处理
                            if (this.autoOpen) {
                                this.$jsBridge.callBackHandler('openFail', { msg: res.message })
                                return
                            }

                            this.messageDialog = {
                                visible: true,
                                rightBtnName: '去做任务',
                                leftBtnName: '取消',
                                leftBtnMethod: () => {
                                    this.messageDialog.visible = false
                                },
                                rightBtnMethod: () => {
                                    this.messageDialog.visible = false

                                    // 跳转斑豆任务
                                    this.$jsBridge.callBackHandler('pushBandouCenterPage')
                                },
                                title: '',
                                content: res.message
                            }
                        }

                        // 处理通用错误码
                        this.handleErrorCode(res)
                    })
                },
                title: '',
                content: '是否确认开通科目三考场视频VIP'
            }
        },
        // 金钱开通方式
        moneyOpenModel () {
            // 除了IOS设备都需要登陆
            if (!this.IOS && !this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')
                return
            }

            // 请求数据
            let postData = {
                currentUserId: this.userInfo.userId,
                cityCode: this.cityCode,
                subject: '3',
                tryBuyFlag: true,
                version: this.version
            }

            this.loading = true
            this.$api.vipPayOpenExamVideo(postData).then(res => {
                this.loading = false
                if (res.code === '200' && res.status) {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // 兼容ios设置类型
                        this.$jsBridge.callBackHandler('setApplePayType', { payType: 3 })

                        // 唤起支付
                        this.$jsBridge.callBackHandler('applyPay', {
                            orderId: res.result,
                            productId: this.examVideoData.productId
                        })

                        return
                    }
                    // 兼容自动开通
                    if (this.autoOpen) {
                        this.$router.replace({
                            name: 'pay',
                            query: {
                                isOpen: this.autoOpen,
                                payId: res.result,
                                money: this.examVideoData.payConPrice > 0 ? this.examVideoData.payConPrice : this.examVideoData.payOrigPrice,
                                type: '5',
                                headShow: '1'
                            }
                        })
                        return
                    }

                    // 跳转付款页
                    this.$router.push({
                        name: 'pay',
                        query: {
                            payId: res.result,
                            money: this.examVideoData.payConPrice > 0 ? this.examVideoData.payConPrice : this.examVideoData.payOrigPrice,
                            type: '5',
                            headShow: '1'
                        }
                    })
                }

                if (res.code === '701') {
                    // 兼容自动开通
                    if (this.autoOpen) {
                        this.$jsBridge.callBackHandler('openFail', { msg: '您有科目三考场视频VIP订单未支付' })
                        return
                    }
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.$router.push({
                                name: 'examThreeVideoOrderDetail',
                                query: { id: res.result, headShow: '1' }
                            })
                        },
                        title: '',
                        content: '您有科目三考场视频VIP订单未支付'
                    }
                }

                // 斑豆异常处理
                if (res.message.indexOf('斑豆不足') > -1) {
                    if (this.autoOpen) {
                        this.$jsBridge.callBackHandler('openFail', { msg: res.message })
                        return
                    }
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去做任务',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false

                            // 跳转斑豆任务
                            this.$jsBridge.callBackHandler('pushBandouCenterPage')
                        },
                        title: '',
                        content: res.message
                    }
                }

                // 处理通用错误码
                this.handleErrorCode(res)
            })
        },
        // 分享开通方式
        shareOpenModel () {
            // 分享开通需要登陆
            if (!this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')
                return
            }

            // 标题
            let title = this.examVideoData.title
            // 内容
            let content = this.examVideoData.content
            // 分享链接
            let shareUrl = this.examVideoData.link
            // 图片链接
            let imageUrl = this.examVideoData.image
            // 页面编码
            let pageCode = 'examroomVideo-detail'

            // 唤起分享
            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 支付回调
        payCallback (v) {
            if (Number(v) === 1) {
                // 开通成功处理
                this.openSuccess()
            } else {
                // 跳转支付结果页
                this.$router.push({ name: 'payResult', query: { result: v, headShow: this.headVisible } })
            }
        },
        // 分享回调
        shareCallback () {
            // 判断车型 || 是否分享开通模式
            if (Number(this.carType) !== 1 || Number(this.examVideoData.openMode) !== 1) {
                return
            }
            // 请求数据
            let postData = {
                shareRecordId: this.examVideoData.shareRecordId,
                times: '1',
                cityCode: this.cityCode,
                tryBuyFlag: true,
                subject: '3'
            }
            this.loading = true
            this.$api.vipShareOpenExamVideo(postData).then(res => {
                this.loading = false
                if (res.status) {
                    if (res.result === 0) {
                        // 开通成功处理
                        this.openSuccess()
                    } else {
                        Toast.success('分享成功')
                    }
                }
            })
        },
        // 获取vip数据
        getVipData () {
            let postData = {
                subject: '3',
                version: this.version
            }

            return this.$api.getVipMatchEntryExamVideo(postData).then(res => {
                if (res.status && res.result) {
                    // 判断是否开通
                    if (res.result.vipFlag) {
                        // 开通成功
                        this.openSuccess()
                    }

                    // 设置vip数据
                    this.vipData = res.result

                    // 设置科三考场视频数据
                    this.examVideoData = res.result.examVipSettingErVideoDTO

                    // 底部按钮字体布局兼容
                    if (this.IOS && this.examVideoData.payConPoint) {
                        this.$nextTick(() => {
                            document.querySelectorAll('.top')[0].style.fontSize = '15px'
                            document.querySelectorAll('.bottom')[0].style.fontSize = '14px'
                        })
                    }
                } else {
                    Toast.fail(res.message)
                }
            })
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || '考场视频VIP'
            // 内容
            let content = '真实考场视频拍摄，让你足不出户全方位看考场~'
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'examroomVideo-detail'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?shareType=h5&appType=${this.appType}&cityCode=${this.cityCode}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || 'http://app.static.public.chetailian.com/share/kskcspVIP_3.png'
            }

            // 唤起分享
            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 获取分享配置信息
        getSetting () {
            return this.$api.getAdSetting({ code: 'examroomVideo-detail' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                }
            })
        },
        // 获取未开通考场视频
        notVipVideoList () {
            let data = {
                subject: 3,
                examPlaceId: this.examPlaceId,
                cityCode: this.cityCode
            }

            this.$api.notVipVideoList(data).then(res => {
                if (res.status && res.result) {
                    this.videoList = res.result
                    if (this.videoList.length === 0) {
                        this.examVisible = false
                    }
                }
            })
        },
        // 初始化
        init () {
            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // 设置考场显示
            this.examVisible = !!this.$jsBridge.hasNativeMethod('pushExamPlaceRoutePage')

            // 设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 设置H5标记
            this.H5 = this.$route.query.shareType === 'h5'

            // 设置城市code
            this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

            // 设置版本
            this.version = this.$jsBridge.callBackHandler('getAppVersion') || ''

            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

            // 设置分享显示
            this.shareVisible = !this.H5

            // 设置头部显示
            this.headVisible = this.$route.query.headShow || '1'

            // 设置自动开通
            this.autoOpen = this.$route.query.isOpen

            // 设置考场id
            this.examPlaceId = this.$route.query.examPlaceId

            // 暴露支付回调方法
            this.$jsBridge.registerHandler('payCallback', this.payCallback)

            // 暴露分享回调方法
            this.$jsBridge.registerHandler('shareCallback', this.shareCallback)

            // 移除refreshCallBack方法
            this.$jsBridge.registerHandler('refreshCallBack', () => {})
        }
    },
    async created () {
        this.init()

        // 获取分享数据
        this.getSetting()

        // 获取未开通考场视频
        this.notVipVideoList()

        // 获取vip数据
        await this.getVipData()

        if (this.autoOpen) {
            await this.submit()
        }
    },
    data () {
        return {
            // 头部显示
            headVisible: '',
            // h5标记
            H5: false,
            // 自动开通
            autoOpen: '',
            // 考场id
            examPlaceId: '',
            // 车型默认小车
            carType: '1',
            // 科三考场视频数据
            examVideoData: {},
            // loading
            loading: false,
            // 城市code
            cityCode: '',
            // 显示分享
            shareVisible: false,
            // 分享数据
            shareData: {},
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            // 用户数据
            userInfo: {},
            // 考场显示
            examVisible: false,
            // fixed布局
            fixed: false,
            // 视频集合
            videoList: [],
            // 弹窗数据
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .video-wrap {
        position: relative;
        z-index: 2;
        width: 365px;
        height: 200px;
        background: #FFFFFF;
        border-radius: 5px 0 0 5px;
        margin: 230px 0 0 10px;

        .video-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 60px;
            padding: 0 10px 0 15px;

            .header-left {
                left: 10px;
                position: absolute;
                z-index: 99;

                img {
                    width: 24px;
                }
            }

            .title {
                flex: 1;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font: 600 20px PingFangSC-Semibold, PingFang SC;
                color: #333333;
            }

            .btn-go-exam {
                display: flex;
                align-items: center;
                justify-content: center;
                background: #fc893a;
                width: 100px;
                height: 30px;
                border-radius: 28px;
                font: 400 15px PingFangSC-Regular, PingFang SC;
                color: #FFFFFF;
            }
        }

        .video-list {
            white-space: nowrap;
            overflow: auto;
            -webkit-overflow-scrolling: touch;

            .video-item {
                display: inline-block;
                margin: 0 0 0 15px;
                position: relative;
                width: 193px;
                height: 124px;
                border-radius: 6px;
                overflow: hidden;

                .cover {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .play {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    background: rgba(0, 0, 0, 0.2);

                    .van-icon {
                        font-size: 26px;
                        color: #ffffff;
                    }
                }

                .time {
                    position: absolute;
                    right: 5px;
                    bottom: 5px;
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
        }

        &.top {
            margin: 0;
            width: 100%;
            height: 180px;
            border-radius: 0;

            .video-item {
                margin: 10px 0 0 10px;
                height: 100px;
                width: 155px;
            }

            .video-list {
                width: 375px;
            }

            .title {
                left: 0;
                font: 600 18px PingFangSC-Semibold, PingFang SC;
                position: absolute;
                width: 100%;
                text-align: center;
            }

            .btn-go-exam {
                position: absolute;
                right: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #fc893a;
                width: 80px;
                height: 24px;
                border-radius: 28px;
                font: 400 12px PingFangSC-Regular, PingFang SC;
                color: #FFFFFF;
            }
        }
    }

    .wrapper {
        background: #fff;

        .van-button {
            height: 100%;
            border: none;
        }

        .van-button__loading {
            margin: 0 auto;
            vertical-align: middle;
        }

        .header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 99;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 60px;
            background: #ffffff;

            .header-main {
                font-size: 18px;
                font-family: PingFangSC;
                font-weight: bold;
                color: #333333;
            }

            .header-left, .header-right {
                display: flex;
                padding: 15px 10px;
                width: 24px;
                height: 24px;
                font-size: 0;
                line-height: 1;

                img {
                    width: 24px;
                    height: 24px;
                }
            }
        }

        .header-pre {
            height: 60px;
        }

        .bg {
            overflow: hidden;
            position: relative;
            line-height: 1;
            font-size: 0;

            img {
                width: 375px;
            }

            .bg-first {
                top: 0;
                z-index: 1;
                position: absolute;
            }

            .bg-other {
                position: relative;
                z-index: 2;
            }
        }

        .rule {
            &.second {
                bottom: 40px;
                white-space: nowrap;
            }

            position: absolute;
            bottom: 225px;
            width: 290px;
            left: 50%;
            z-index: 2;
            transform: translateX(-50%);

            p {
                margin-bottom: 7.5px;
                text-indent: - 25px;
                margin-left: 25px;
                font: 400 13px PingFangSC-Regular, PingFang SC;
                color: #4F5798;
                line-height: 24px;
                word-break: break-word;
            }

            .index {
                background: #4f5798;
                border-radius: 100%;
                text-indent: 0;
                margin-right: 10px;
                display: inline-block;
                width: 16px;
                color: #fff;
                height: 16px;
                font-size: 12px;
                line-height: 16px;
                text-align: center;
            }

            .number {
                color: #FF6100;
                font-weight: normal;
            }
        }

        .footer-pre {
            height: 49px;
        }

        .footer {
            position: fixed;
            z-index: 3;
            bottom: 0;
            width: 100%;
            height: 49px;
            border-top: 1px solid #EEEEEE;
            background: #ffffff;
            display: flex;
            justify-content: space-between;

            span {
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .first {
                flex-direction: column;
                flex: 1;
                font-family: PingFangSC;
                font-weight: 600;
                color: rgba(255, 80, 80, 1);

                .top {
                    color: #FF5050;
                    font-size: 18px;
                }

                .bottom {
                    color: #999999;
                    font-size: 14px;
                    text-decoration: line-through;
                }
            }

            .second {
                flex: 1;
                font-size: 17px;
                font-family: PingFangSC;
                font-weight: bold;
                color: #333333;

                b {
                    font-size: 13px;
                    font-weight: normal;
                }
            }

            .third {
                width: 80px;
                background: #FFEED2;
                font-size: 18px;
                font-family: PingFangSC;
                font-weight: bold;
                color: #D4A36B;
            }

            .fourth {
                border-radius: 0;
                width: 110px;
                background: #F5DDB6;
                font-size: 17px;
                font-family: PingFangSC;
                font-weight: bold;
                color: #A86F2F;
            }

            .recovery {
                border-right: 1px solid #fff;
                border-radius: 0;
                width: 110px;
                background: #F5DDB6;
                font-size: 17px;
                font-family: PingFangSC;
                font-weight: bold;
                color: #A86F2F;
            }
        }

        .btn-none-buy {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            font-size: 15px;
            font-weight: bold;
            color: #999999;
            background: #F0F0F0;
        }
    }
</style>
